import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.9996 6.89961V17.0996M8.09961 10.4996V17.0996M15.8996 12.8996V17.0996M4.49961 21.8996H19.4996C20.8251 21.8996 21.8996 20.8251 21.8996 19.4996V4.49961C21.8996 3.17413 20.8251 2.09961 19.4996 2.09961H4.49961C3.17413 2.09961 2.09961 3.17413 2.09961 4.49961V19.4996C2.09961 20.8251 3.17413 21.8996 4.49961 21.8996Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgBar);
export { ForwardRef as ReactComponent };
